import { render } from "./BuyersPage.vue?vue&type=template&id=0e5172fa&scoped=true"
import script from "./BuyersPage.vue?vue&type=script&lang=js"
export * from "./BuyersPage.vue?vue&type=script&lang=js"

import "./BuyersPage.vue?vue&type=style&index=0&id=0e5172fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5172fa"]])

export default __exports__